import { useEffect as t, useReducer as e, createElement as r } from "react";
function n() {
  let n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let i = arguments.length > 1 ? arguments[1] : undefined;
  let f = function () {
      let t = {};
      return {
        t(e, r) {
          "function" == typeof r && (t[e] || (t[e] = new Set()), t[e].add(r));
        },
        o(e, r) {
          Object.keys(t).forEach(n => {
            (e.startsWith(n) || n.startsWith(e)) && t[n].forEach(t => t(r));
          });
        },
        u(e, r) {
          "function" == typeof r && (t[e].delete(r), 0 === t[e].size && delete t[e]);
        }
      };
    }(),
    l = n,
    c = n;
  f.t(".", i);
  let y = {
      i: [],
      l(t, e, n, o) {
        let u = u => {
          let i = e.length - 1,
            f = e.length ? e.reduce((t, e, r) => r === i ? t[e](n, o) : t[e], p) : p(n, o); /*#__PURE__*/
          return r(t, {
            ...u,
            store: f
          });
        };
        return u.displayName = "withStore(".concat(t.displayName || t.name || "Component", ")"), u;
      },
      get(t, e) {
        return "prototype" === e ? {} : (this.i.push(e), new Proxy(t, y));
      },
      apply(e, r, n) {
        let i = e(),
          f = n[0],
          y = n[1],
          p = this.i.slice();
        if (this.i = [], 3 === i) return this.l(n[0], p, n[1], n[2]);
        if (!p.length) {
          let t = w();
          return 2 === i && h(".", y), [l, t, d()];
        }
        let s = p.join("."),
          a = w(s),
          S = d(s),
          b = o(l, s),
          v = void 0 !== f && void 0 === b && void 0 === o(c, s);
        return v && (b = f, c = u(c, p, b), l = u(l, p, b)), 2 === i && (t(() => {
          v && a(b);
        }, []), h("." + s, y)), [b, a, S];
      }
    },
    p = new Proxy(() => 2, y),
    s = new Proxy(() => 1, y),
    a = new Proxy(() => 3, y);
  function h(r, n) {
    let o = e(() => ({}), 0)[1];
    t(() => (f.t(r, o), f.t(".", n), () => {
      f.u(r, o), f.u(".", n);
    }), [r]);
  }
  function w() {
    let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    let e = Array.isArray(t) ? t : t.split(".");
    return r => {
      let n = l,
        i = r;
      "function" == typeof r && (i = r(o(l, t))), l = t ? u(l, e, i) : i, f.o("." + t, {
        prevStore: n,
        store: l
      });
    };
  }
  function d(t) {
    return () => w(t)(o(c, t));
  }
  return {
    useStore: p,
    getStore: s,
    withStore: a
  };
}
function o(t, e) {
  return e ? (Array.isArray(e) ? e : e.split(".")).reduce((t, e) => null == t ? void 0 : t[e], t) : t;
}
function u() {
  let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let [e, ...r] = arguments.length > 1 ? arguments[1] : undefined;
  let n = arguments.length > 2 ? arguments[2] : undefined;
  let o = Array.isArray(t) ? [...t] : {
    ...t
  };
  return o[e] = r.length ? u(t[e], r, n) : n, o;
}
export { n as default };